import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import {
  branch,
  compose,
  withHandlers,
  withState,
  withStateHandlers,
} from 'recompose';
import camelize from 'camelize';

import { withTranslationProvider } from '../../Common/Translations';
import { undecorated as undecoratedActivateButton } from './ActivateButton';
import { connectCreditBalanceDispatch, isGiftCardCode } from '../../GiftCardCredit/WithRedeem';
import { getErrorMsgAsString } from '../../Common/ErrorMsg';
import { fetchRedeemGiftCard } from '../../Common/Providers/GiftCardApi';

const isRedirectToAppPushPage = (platforms) => {
  if (platforms.length == 1 && platforms[0] == 'mobile') {
    return true
  }

  return false
}

export const withGiftCardHandler = compose(
  connectCreditBalanceDispatch,
  withHandlers({
    onClick: ({
      inputCode,
      clearInputCode, 
      setErrorMessage,
      setCreditBalance,
      t,
    }) => () => {
      fetchRedeemGiftCard({ inputCode }).done((resp) => {
        const { creditBalance, giftCardValue } = resp.data;
        setCreditBalance(creditBalance);
        setErrorMessage('');
        toastr.success(
          t("account.gift_card_success_redemption","Successfully redeemed eGift Card!"), '',
          { positionClass: 'toast-bottom-full-width' },
        );
      }).fail(({ responseJSON: { errors } }) => {
        setErrorMessage(getErrorMsgAsString(errors));
      });
      clearInputCode();
    },
  }),
);

export const withVoucherHandler = compose(
  withHandlers({
    onClick: (props) => async () => {
      const { 
        inputCode, 
        clearInputCode, 
        activateVoucher, 
        getData, 
        setActivated,
        setErrorMessage,
        t,
        tRoute
      } = props

      try {
        const { success, data } = await activateVoucher(inputCode);

        if (success) {
          const { 
            claimVoucher: { 
              promotionPlatforms 
            },
          } = camelize(data)

          setActivated(true)
          clearInputCode();
          const redirectToAppPushPage = isRedirectToAppPushPage(promotionPlatforms)
          
          if (redirectToAppPushPage) {
            window.location.href = tRoute('/appvoucher')
          } else {
            getData(1)
          }

          toastr.success(
              t("account.voucher_success_activated", "Voucher is successfully activated!"), '',
              { positionClass: 'toast-bottom-full-width' },
            );
        }

      } catch (error) {
        const { responseJSON } = error
        setActivated(false);
        clearInputCode();
        setErrorMessage(responseJSON.errors)
      }
    }
  }),
);

const ActivateButton = compose(
  branch(
    isGiftCardCode,
    withGiftCardHandler,
    withVoucherHandler,
  ),
)(undecoratedActivateButton);
class VoucherActivationForm extends Component {
  render() {
    const { onChange, getData, inputCode, t, errorMessage } = this.props;

    return (
      <div className='voucher-activation-form'>
        <div className='row'>
          <div className='col-lg-6 col-md-12'>
            <input
              type='text'
              className='form-control border border-secondary mb-1'
              id='voucherCodeTextbox'
              placeholder={t("account.voucher_activation_form_placeholder", "Enter Voucher Code here")}
              onChange={onChange}
              value={inputCode}
            />
          </div>
          <div className='col-lg-3 col-md-12'>
            <ActivateButton
              {...this.props}
              getData={getData}
            />
          </div>
        </div>
        <div className='text-danger'>
          <p>
            {
              errorMessage
            }
          </p>
        </div>
      </div>
    )
  }
}

VoucherActivationForm.PropTypes = {
  activateVoucher: PropTypes.func,
};

const withActivationFormState = compose(
  withState('isActivated', 'setActivated', false),
  withState('errorMessage', 'setErrorMessage', ''),
)

const withOnChange = compose(
  withStateHandlers({
    inputCode: ''
  }, {
    onChange: () => ({ target: { value } }) => ({
      inputCode: value
    }),
    clearInputCode: () => () => ({
      inputCode: ''
    }),
  }),
);

const enhance = compose(
  withOnChange,
  withActivationFormState,
  withTranslationProvider
);


export default enhance(VoucherActivationForm)


// WEBPACK FOOTER //
// ./src/Account/Voucher/VoucherActivationForm.js